export const Badge = ({ text, icon, className = "" }) => (
    <span className={`custom-badge text-capitalize ${className}`}>
        {icon} {text}
    </span>
);

export const Skeleton = ({ height = 20, width = "100%", className = "" }) => (
    <div className={`skeleton ${className}`} style={{ height, width }} />
);

export const Stat = ({ label, value }) => (
    <div className="col-3 mb-3">
        <div className="stat-card">
            <div className="stat-number">{value || 0}</div>
            <div className="stat-label">{label}</div>
        </div>
    </div>
);

export const DetailCard = ({ title, icon, children }) => (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
        {title ? (
            <div className="p-3">
                <h5 className="fw-semibold d-flex align-items-center gap-2">
                    {icon} {title}
                </h5>
                <hr className="m-0" />
            </div>
        ) : ""}
        <div className="card-body">{children}</div>
    </div>
);

export const FieldRow = ({ label, value }) => (
    <div className="field-row">
        <span className="field-label">{label}</span>
        <span className="field-value  text-capitalize">{value || "-"}</span>
    </div>
);

export const StatusPill = ({ active, activeText = "Active", inactiveText = "Deactive" }) => (
    <span className={`badge rounded-pill ${active ? "text-bg-success" : "text-bg-danger"}`}>
        {active ? activeText : inactiveText}
    </span>
);

// Document tile used by the car view's Documents panel: an icon, a title and a
// verified/pending state, clickable to open the upload-or-replace modal.
export const KycCard = ({ title, icon, verified = false, onClick }) => (
    <div className="col-12 col-sm-6 col-xl-4">
        <button
            type="button"
            onClick={onClick}
            className="w-100 text-start border-0 bg-transparent p-0"
        >
            <div className="card border-0 shadow-sm rounded-4 h-100 kyc-card">
                <div className="card-body d-flex align-items-center gap-3 justify-content-center flex-column text-center">
                    <span className={`kyc-icon ${verified ? "" : "pending"}`}>
                        {icon}
                    </span>
                    <div className="">
                        <div className="fw-semibold text-capitalize">{title}</div>
                        <span className={`badge rounded-pill ${verified ? "text-bg-success" : "text-bg-warning"}`}>
                            {verified ? "Uploaded" : "Pending"}
                        </span>
                    </div>
                </div>
            </div>
        </button>
    </div>
);
